import { useApp } from '../context/AppContext.jsx';
import { cx } from '../lib/util.js';

export function ToastStack() {
  const { toasts } = useApp();

  return (
    <div className="fixed right-4 top-4 z-[100] flex flex-col items-end gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          className={cx(
            'animate-sg-pop flex items-center gap-2.5 border px-4 py-2.5 font-mono text-xs font-bold uppercase tracking-widest',
            t.accent === 'ember'
              ? 'border-ember/80 bg-[#1a0510] text-ember shadow-neon-ember'
              : 'border-neon/80 bg-[#001412] text-neon shadow-neon-teal'
          )}
        >
          <span className="inline-block h-2 w-2 animate-pulse bg-current" />
          {t.message}
        </div>
      ))}
    </div>
  );
}